const items = document.querySelectorAll('.profile__orders-item');

if (items.length) {
  items[0].classList.add('active');
  items[0].style.maxHeight = `5000px`;

  items.forEach((item) => {
    const itemToggle = item.querySelector('.profile__orders-item__nav');
    const itemBody = item.querySelector('.profile__orders-item__body');
    const itemBottom = item.querySelector('.profile__orders-item__bottom');

    itemToggle.addEventListener('click', () => {
      const itemH =
        itemToggle.clientHeight +
        itemBody.scrollHeight +
        itemBottom.scrollHeight +
        60;

      if (item.classList.contains('active')) {
        item.classList.remove('active')
        item.style.maxHeight = `${itemToggle.clientHeight}px`;
        return
      }
      items.forEach((i) => {
        i.classList.remove('active');
        i.style.maxHeight = `${itemToggle.clientHeight}px`;
      });

      item.classList.add('active');
      item.style.maxHeight = `${itemH}px`;
    });

  });
}
